import { render, staticRenderFns } from "./course-input.vue?vue&type=template&id=a6684064&"
import script from "./course-input.vue?vue&type=script&lang=js&"
export * from "./course-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports